/**
 * Import and instantiate front end modules
 */

require('./blocks/location-map');
require('./blocks/retentions-products-offered');

import { updateBodyClassname } from './core/body';
import { mobileNav } from './core/mobile-nav';
import { accordion } from './core/accordion';
import { infoBlock } from './core/info-block';
import { showList } from './core/show-list';
import { stickyBanner } from './core/sticky-banner';
import { tabsBlock } from './core/tabs-block';
import { frame } from './core/frame';
import { headerHover } from './core/header';
import Glide from '@glidejs/glide';

const slider = document.querySelector('.glide');
if (slider) {
	const glide = new Glide(slider);

	glide.mount();
}

const homeHeroSliders = document.querySelectorAll('.home-hero-banner__slider');

if (homeHeroSliders.length) {

	const bulletStyle = document.createElement('style');
	document.head.appendChild(bulletStyle);

	const autoplayDuration = 5000;
	const transitionDuration = 800;
	bulletStyle.textContent = `
		.bullet-progress-animation::before {
			animation-duration: ${autoplayDuration}ms !important;
		}

		.home-hero-banner__slider--paused .bullet-progress-animation::before {
			animation-play-state: paused !important;
		}
	`;

	homeHeroSliders.forEach(slider => {
		const glide = new Glide(slider, {
			type: 'carousel',
			perView: 1,
			focusAt: 'center',
			gap: 0,
			autoplay: autoplayDuration,
			animationDuration: transitionDuration,
			swipeThreshold: Infinity,
			dragThreshold: Infinity,
			touchRatio: 0,
			keyboard: true,
			hoverpause: true
		});

		const fadeBackgroundImages = (index) => {
			const sliderContainer = slider.closest('.home-hero-banner');
			if (!sliderContainer) return;
			
			const activeBackground = sliderContainer.querySelector(`.home-hero-banner__background-slide.home-hero-banner__background-slide--active`);
			const targetBackground = sliderContainer.querySelector(`.home-hero-banner__background-${index}`);
			if (!targetBackground) return;

			if (activeBackground && activeBackground !== targetBackground) {
				activeBackground.style.opacity = 0;
				setTimeout(() => {
					activeBackground.classList.remove('home-hero-banner__background-slide--active');
					activeBackground.classList.add('home-hero-banner__background-slide--hidden');
					targetBackground.classList.remove('home-hero-banner__background-slide--hidden');
					targetBackground.classList.add('home-hero-banner__background-slide--active');
					targetBackground.style.opacity = 1;
				}, 0);
			} else if (!activeBackground) {
				targetBackground.classList.remove('home-hero-banner__background-slide--hidden');
				targetBackground.classList.add('home-hero-banner__background-slide--active');
				targetBackground.style.opacity = 1;
			}
		};

		// Add animated SVG ring to active bullet
		const updateProgressBullet = (activeIndex) => {
			const bullets = slider.querySelectorAll('.glide__bullet');

			bullets.forEach((bullet, i) => {
				const oldProgressRing = bullet.querySelector('.bullet-progress-ring');
				if (oldProgressRing) oldProgressRing.remove();

				if (i === activeIndex) {
					const progressRing = document.createElement('div');
					progressRing.className = 'bullet-progress-ring';
					const ringDuration = (autoplayDuration - transitionDuration) / 1000;
					progressRing.innerHTML = `
						<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
							<circle cx="16" cy="16" r="14" fill="none" stroke="var(--c-home-hero-banner-button)" stroke-width="2" stroke-dasharray="88" stroke-dashoffset="88">
								<animate attributeName="stroke-dashoffset" from="88" to="0" dur="${ringDuration}s" fill="freeze" />
							</circle>
						</svg>
					`;
					bullet.appendChild(progressRing);
				}
			});
		};

		glide.on('mount.after', () => {
			fadeBackgroundImages(0);
			updateProgressBullet(0);
		});

		glide.on('run', () => {
			const bullets = slider.querySelectorAll('.glide__bullet');
			bullets.forEach(bullet => {
				const ring = bullet.querySelector('.bullet-progress-ring');
				if (ring) ring.remove();
			});
		});

		glide.on('run.after', () => {
			const index = glide.index;
			fadeBackgroundImages(index);
			updateProgressBullet(index);
		});

		// Pause / resume custom progress animations on hover
		const pauseProgressAnimations = () => {
			slider.classList.add('home-hero-banner__slider--paused');

			slider.querySelectorAll('.bullet-progress-ring svg').forEach(svg => {
				if (typeof svg.pauseAnimations === 'function') {
					svg.pauseAnimations();
				}
			});
		};

		const resumeProgressAnimations = () => {
			slider.classList.remove('home-hero-banner__slider--paused');

			slider.querySelectorAll('.bullet-progress-ring svg').forEach(svg => {
				if (typeof svg.unpauseAnimations === 'function') {
					svg.unpauseAnimations();
				}
			});
		};

		slider.addEventListener('mouseenter', pauseProgressAnimations);
		slider.addEventListener('mouseleave', resumeProgressAnimations);

		glide.mount();
	});
}

updateBodyClassname();
mobileNav();
accordion();
infoBlock();
showList();
stickyBanner();
tabsBlock();
frame();
headerHover();